<template>
  <div class="indexbodyitem">
    <div class="row" v-if="this.layout=='waterfall'">
      <div
        :class="[
        {'col-sm-8 item':products.length==3},
        {'col-sm-6 item':products.length==2},
        {'col-12 item':products.length==1},
      ]"
      >
        <v-saveprice
          v-if="products[0].max_discount&&products[0].max_discount!=0"
          :saveprice="products[0].max_discount"
        ></v-saveprice>
        <a
          :href="'/products/'+products[0].slug"
          class="product_card_backgorund"
          :class="products.length==2?'thumbnail':'bigphoto'"
        >
          <img
            data-sizes="auto"
            :data-src="products[0].image"
            :data-srcset="products[0].feature_image?products[0].feature_image.srcset:defaultImage"
            class="lazyload"
            @error.once="imageFailure($event,defaultImage)"
          />
          <span class="fallback-text">{{products[0].post_title}}</span>
        </a>
        <a :href="'/products/'+products[0].slug" class="intro text_font">
          <span class="intro_name">{{products[0].post_title}}</span>
          <p>
            <!-- <span class="iconfont icon-jian"></span> -->
            <v-selectprice :price="products[0].min_price"></v-selectprice>
            <!-- <span class="iconfont icon-jia"></span> -->
          </p>
        </a>
      </div>
      <div
        v-if="products.length>1"
        :class="[
        {'col-sm-4':products.length==3},
        {'col-sm-6':products.length==2},
        {'order-first':index%2==0},
      ]"
      >
        <div v-if="products[1] " class="item">
          <v-saveprice
            v-if="products[1].max_discount&&products[1].max_discount!=0"
            :saveprice="products[1].max_discount"
          ></v-saveprice>
          <a :href="'/products/'+products[1].slug" class="thumbnail product_card_backgorund">
            <img
              data-sizes="auto"
              :data-src="products[1].image"
              class="lazyload"
              :data-srcset="products[1].feature_image?products[1].feature_image.srcset:defaultImage"
              @error.once="imageFailure($event,defaultImage)"
            />
            <span class="fallback-text">{{products[1].post_title}}</span>
          </a>
          <a :href="'/products/'+products[1].slug" class="intro text_font">
            <span class="intro_name">{{products[1].post_title}}</span>
            <p>
              <!-- <span class="iconfont icon-jian"></span> -->
              <v-selectprice :price="products[1].min_price"></v-selectprice>
              <!-- <span class="iconfont icon-jia"></span> -->
            </p>
          </a>
        </div>
        <div v-if="products[2]" class="item">
          <v-saveprice
            v-if="products[2].max_discount&&products[2].max_discount!=0"
            :saveprice="products[2].max_discount"
          ></v-saveprice>
          <a :href="'/products/'+products[2].slug" class="thumbnail product_card_backgorund">
            <img
              data-sizes="auto"
              :data-src="products[2].image"
              class="lazyload"
              :data-srcset="products[2].feature_image?products[2].feature_image.srcset:defaultImage"
              @error.once="imageFailure($event,defaultImage)"
            />
            <span class="fallback-text">{{products[2].post_title}}</span>
          </a>
          <a :href="'/products/'+products[2].slug" class="intro text_font">
            <span class="intro_name">{{products[2].post_title}}</span>
            <p>
              <!-- <span class="iconfont icon-jian"></span> -->
              <v-selectprice :price="products[2].min_price"></v-selectprice>
              <!-- <span class="iconfont icon-jia"></span> -->
            </p>
          </a>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div v-for=" item in products" :key="item.ID" class="col-sm-4 item">
        <v-saveprice v-if="item.max_discount&&item.max_discount!=0" :saveprice="item.max_discount"></v-saveprice>
        <a
          :href="collectionsslug?'/collections/'+collectionsslug+'/products/'+item.slug: '/products/'+item.slug"
          class="thumbnail product_card_backgorund"
        >
          <img
            data-sizes="
            (max-width: 358px) 189px,
            (max-width: 576px) 295px,
            (max-width: 768px) 135px,
            (max-width: 992px) 189px,
             215px"
            :data-src="item.image"
            class="lazyload"
            :data-srcset="item.feature_image?item.feature_image.srcset:defaultImage"
            @error.once="imageFailure($event,defaultImage)"
          />
        </a>
        <a
          :href="collectionsslug?'/collections/'+collectionsslug+'/products/'+item.slug: '/products/'+item.slug"
          class="intro text_font"
        >
          <span class="intro_name">{{item.post_title}}</span>
          <p>
            <!-- <span class="iconfont icon-jian"></span> -->
            <v-selectprice :price="item.min_price"></v-selectprice>
            <!-- <span class="iconfont icon-jia"></span> -->
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import defaultImage from "../../../../public/images/no-image.gif";

export default {
  props: ["products", "index", "layout", "collectionsslug"],
  data() {
    return {
      defaultImage
    };
  },
  mounted() {
    console.log("瀑布流商品", this.products, this.layout);
  }
};
</script>
<style scoped lang='scss'>
.indexbodyitem {
  margin-top: 20px;

  .row {
    .item {
      position: relative;

      .thumbnail {
        min-height: 255px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f9f1e6;
        padding: 20px 0;
        margin: 0;
        overflow: hidden;

        img {
          max-width: 90%;
          max-height: 215px;
        }
        &:hover {
          opacity: 0.9;
        }
      }
      .bigphoto {
        min-height: 580px;
        padding: 20px 0;
        background: #f9f1e6;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          max-width: 90%;
          max-height: 540px;
          &:hover {
            opacity: 0.9;
          }
        }
        // &:hover {
        //   transition: opacity 0.15s ease-in;
        //   opacity: 0.9;
        // }
      }

      a {
        border: none;
      }

      .intro {
        display: block;
        text-decoration: none;
        text-align: center;
        color: black;
        font-size: 1.2em;
        padding-top: 13px;
        margin-bottom: 15px;
        padding-bottom: 15px;
        p {
          margin: 0;
          // display: inline-block;
          span {
            font-size: 14px;
            color: black;
            font-weight: 600;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .indexbodyitem {
    .row {
      .thumbnail {
        min-height: 165px !important;

        img {
          max-height: 205px !important;
        }
      }

      .bigphoto {
        min-height: 480px !important;

        img {
          max-height: 440px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .indexbodyitem {
    .row {
      .thumbnail {
        min-height: 115px !important;

        img {
          max-height: 155px !important;
        }
      }

      .bigphoto {
        min-height: 440px !important;

        img {
          max-height: 400px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .indexbodyitem {
    .row {
      .thumbnail {
        min-height: 335px !important;
        height: 335px !important;

        img {
          max-height: 295px !important;
        }
      }

      .bigphoto {
        min-height: 335px !important;
        height: 335px !important;

        img {
          max-height: 295px !important;
        }
      }
    }
  }
}
</style>